(function () {
  const REGISTRY_KEY = '__secondHeaderInstances';
  const instances = window[REGISTRY_KEY] || (window[REGISTRY_KEY] = new Map());
  const FOOTER_REGISTRY_KEY = '__secondFooterInstances';
  const footerInstances = window[FOOTER_REGISTRY_KEY] || (window[FOOTER_REGISTRY_KEY] = new Map());
  const prefersReducedMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  function getContext() {
    const containers = Array.from(document.querySelectorAll('[data-barba="container"]'));
    const latestContainer = containers.length ? containers[containers.length - 1] : null;
    const node = (latestContainer && latestContainer.querySelector('#second-header-context'))
      || Array.from(document.querySelectorAll('#second-header-context')).pop()
      || null;
    return {
      variant: ((node && node.dataset.secondHeaderVariant) || '').trim().toLowerCase(),
      resource: ((node && node.dataset.secondHeaderResource) || '').trim().toLowerCase(),
      handle: ((node && node.dataset.secondHeaderHandle) || '').trim().toLowerCase(),
      template: ((node && node.dataset.secondHeaderTemplate) || '').trim().toLowerCase()
    };
  }

  function setExpandableState(panel, open) {
    if (!panel) return;

    panel.classList.add('is-animating');

    const finish = function (event) {
      if (event && event.propertyName !== 'max-height') return;
      panel.removeEventListener('transitionend', finish);
      panel.classList.remove('is-animating');
      if (open) {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      } else {
        panel.style.maxHeight = '0px';
      }
    };

    panel.removeEventListener('transitionend', finish);
    panel.addEventListener('transitionend', finish, { once: true });

    if (open) {
      panel.classList.add('is-open');
      panel.style.maxHeight = '0px';
      panel.offsetHeight;
      panel.style.maxHeight = panel.scrollHeight + 'px';
    } else {
      panel.style.maxHeight = panel.scrollHeight + 'px';
      panel.offsetHeight;
      panel.classList.remove('is-open');
      panel.style.maxHeight = '0px';
    }
  }

  function requestLayoutSettle() {
    if (typeof window.__persistentRouterSettleGeometry === 'function') {
      window.__persistentRouterSettleGeometry();
      return;
    }

    try {
      window.dispatchEvent(new CustomEvent('theme:layout-change'));
      document.dispatchEvent(new CustomEvent('theme:layout-change'));
    } catch (_) {}
  }

  function SecondHeader(root) {
    this.root = root;
    this.variant = (root.dataset.shVariant || '').trim().toLowerCase();
    this.storageKey = root.dataset.introKey || ('sh_seen_' + this.variant);
    this.bodyCoveringClasses = ['has-second-header-covering'];
    this.bodyCollapsedClasses = ['has-second-header-collapsed'];
    if (this.variant) {
      this.bodyCoveringClasses.push('has-second-header-' + this.variant + '-covering');
      this.bodyCollapsedClasses.push('has-second-header-' + this.variant + '-collapsed');
    }
    this.mobileBp = parseInt(root.dataset.mobileBp || '749', 10);
    this.tabletBp = parseInt(root.dataset.tabletBp || '991', 10);
    this.introDelay = parseInt(root.dataset.introDelay || '420', 10);

    this.primarySection = document.querySelector('#shopify-section-header-2');
    this.primaryRoot = document.querySelector('#shopify-section-header-2 [data-h2-header-root]');
    this.primaryHeader = document.querySelector('#shopify-section-header-2 [data-h2-header]');
    this.primaryAnnouncement = document.querySelector('#shopify-section-header-2 .h2-announcement');
    this.primaryRow = document.querySelector('#shopify-section-header-2 .h2-header-row');
    this.primaryLeftLogoLink = document.querySelector('#shopify-section-header-2 .h2-logo-left a');

    this.announcementExpanded = root.querySelector('[data-sh-announcement-expanded]');
    this.announcementCollapsed = root.querySelector('[data-sh-announcement-collapsed]');
    this.announcementBar = root.querySelector('.fff-sh__announcement');
    this.collapseBtn = root.querySelector('[data-sh-collapse]');
    this.expandBtn = root.querySelector('[data-sh-expand]');
    this.drawerOpenBtn = root.querySelector('[data-sh-drawer-open]');
    this.drawerCloseBtn = root.querySelector('[data-sh-drawer-close]');
    this.drawer = root.querySelector('[data-sh-drawer]');
    this.drawerBackdrop = root.querySelector('[data-sh-drawer-backdrop]');
    this.desktopLinks = Array.from(root.querySelectorAll('[data-sh-desktop-toggle]'));
    this.desktopPlainLinks = Array.from(root.querySelectorAll('.fff-sh__desktop-item:not(.has-children) .fff-sh__desktop-link'));
    this.desktopAllLinks = Array.from(root.querySelectorAll('.fff-sh__desktop-nav-list .fff-sh__desktop-link'));
    this.desktopSpecialLink = root.querySelector('.fff-sh__special--desktop');
    this.desktopPanels = Array.from(root.querySelectorAll('[data-sh-desktop-panel]'));
    this.desktopSubmenuImageLinks = Array.from(root.querySelectorAll('[data-sh-submenu-image-target]'));
    this.desktopSubmenuNavLinks = Array.from(root.querySelectorAll('.fff-sh__submenu-link, .fff-sh__submenu-image'));
    this.drawerSubtoggles = Array.from(root.querySelectorAll('[data-sh-drawer-toggle]'));
    this.drawerParentLinks = Array.from(root.querySelectorAll('[data-sh-drawer-parent-link]'));
    this.drawerNavLinks = Array.from(root.querySelectorAll('[data-sh-drawer-nav]'));
    this.drawerSubmenuNavLinks = Array.from(root.querySelectorAll('.fff-sh__drawer-sublink'));
    this.drawerSpecialLinks = Array.from(root.querySelectorAll('.fff-sh__drawer-special'));
    this.row = root.querySelector('.fff-sh__row');
    this.desktopNavList = root.querySelector('.fff-sh__desktop-nav-list');
    this.submenuShell = root.querySelector('.fff-sh__submenu-shell');
    this.drawerLinks = Array.from(root.querySelectorAll('.fff-sh__drawer-link'));

    this.activeDesktopIndex = null;
    this.active = false;
    this.scrollTicking = false;
    this.mutationTicking = false;
    this.mobileManualExpandReveal = false;
    this.desktopAnnouncementHeight = 0;
    this.mobileAnnouncementHeight = 0;
    this.desktopAnnouncementInnerHeight = 0;
    this.mobileAnnouncementInnerHeight = 0;
    this.desktopAnnouncementPadTop = 0;
    this.desktopAnnouncementPadBottom = 0;
    this.mobileAnnouncementPadTop = 0;
    this.mobileAnnouncementPadBottom = 0;
    this.pendingDrawerCloseForNav = false;
    this.cleanupFns = [];
    this.timers = [];
    this.mutationObserver = null;
    this.desktopPanelResetTimer = null;
    this.onOutsideClick = this.handleOutsideClick.bind(this);
    this.onResize = this.handleResize.bind(this);
    this.onScroll = this.handleScroll.bind(this);
    this.onKeydown = this.handleKeydown.bind(this);

    this.bind();
    this.refresh();
  }

  SecondHeader.prototype.isMobile = function () {
    return window.innerWidth <= this.mobileBp;
  };

  SecondHeader.prototype.isDesktop = function () {
    return window.innerWidth > this.tabletBp;
  };

  SecondHeader.prototype.addListener = function (target, type, handler, options) {
    if (!target || typeof target.addEventListener !== 'function') return;
    target.addEventListener(type, handler, options);
    this.cleanupFns.push(function () {
      try {
        target.removeEventListener(type, handler, options);
      } catch (_) {}
    });
  };

  SecondHeader.prototype.setTimer = function (fn, delay) {
    const id = window.setTimeout(fn, delay);
    this.timers.push(id);
    return id;
  };

  SecondHeader.prototype.getDrawerCloseLeadMs = function () {
    const itemCount = this.drawer ? this.drawer.querySelectorAll('.fff-sh__drawer-item').length : 0;
    return Math.min(900, Math.max(180, 80 + (Math.max(0, itemCount - 1) * 45)));
  };

  SecondHeader.prototype.bind = function () {
    const self = this;

    function isCurrentSecondHeaderUrl(link) {
      if (!link) return false;
      try {
        const href = (typeof link.getAttribute === 'function' && link.getAttribute('href')) || link.href || '';
        if (!href) return false;
        const url = new URL(href, window.location.href);
        if (url.hash) return false;
        return url.origin === window.location.origin &&
          url.pathname === window.location.pathname &&
          url.search === window.location.search;
      } catch (_) {
        return false;
      }
    }

    function consumeCurrentPageNavigation(link, event) {
      if (!isCurrentSecondHeaderUrl(link)) return false;
      if (event && typeof event.preventDefault === 'function') event.preventDefault();
      if (event && typeof event.stopPropagation === 'function') event.stopPropagation();
      if (event && typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      self.closeDesktopPanels();
      self.closeDrawerForNavigation(link);
      return true;
    }

    if (this.collapseBtn) {
      this.addListener(this.collapseBtn, 'click', function (event) {
        event.preventDefault();
        self.collapseShell();
      });
    }

    if (this.expandBtn) {
      this.addListener(this.expandBtn, 'click', function (event) {
        event.preventDefault();
        self.expandShell();
      });
    }

    if (this.announcementBar) {
      this.addListener(this.announcementBar, 'click', function (event) {
        if (event.target && event.target.closest('[data-sh-collapse], [data-sh-expand]')) return;
        event.preventDefault();
        if (self.root.classList.contains('is-shell-collapsed')) {
          self.expandShell();
        } else {
          self.collapseShell();
        }
      });
    }

    if (this.drawerOpenBtn) {
      this.addListener(this.drawerOpenBtn, 'click', function (event) {
        event.preventDefault();
        self.openDrawer();
      });
    }

    if (this.drawerCloseBtn) {
      this.addListener(this.drawerCloseBtn, 'click', function (event) {
        event.preventDefault();
        self.closeDrawer();
      });
    }

    if (this.drawerBackdrop) {
      this.addListener(this.drawerBackdrop, 'click', function () {
        self.closeDrawer();
      });
    }

    this.desktopLinks.forEach(function (link) {
      const index = String(link.dataset.shDesktopToggle || '');
      self.addListener(link, 'mouseenter', function () {
        if (!self.isDesktop()) return;
        self.openDesktopPanel(index);
      });
      self.addListener(link, 'focus', function () {
        if (!self.isDesktop()) return;
        self.openDesktopPanel(index);
      });
      self.addListener(link, 'click', function (event) {
        if (!self.isDesktop()) return;
        event.preventDefault();
        self.toggleDesktopPanel(index);
      });
    });

    this.desktopPlainLinks.forEach(function (link) {
      self.addListener(link, 'mouseenter', function () {
        if (!self.isDesktop()) return;
        self.closeDesktopPanels();
      });
      self.addListener(link, 'focus', function () {
        if (!self.isDesktop()) return;
        self.closeDesktopPanels();
      });
    });

    if (this.desktopSpecialLink) {
      this.addListener(this.desktopSpecialLink, 'mouseenter', function () {
        if (!self.isDesktop()) return;
        self.closeDesktopPanels();
      });
      this.addListener(this.desktopSpecialLink, 'focus', function () {
        if (!self.isDesktop()) return;
        self.closeDesktopPanels();
      });
    }

    this.desktopSubmenuImageLinks.forEach(function (link) {
      self.addListener(link, 'mouseenter', function () {
        if (!self.isDesktop()) return;
        self.activateDesktopSubmenuImage(link);
      });
      self.addListener(link, 'focus', function () {
        if (!self.isDesktop()) return;
        self.activateDesktopSubmenuImage(link);
      });
    });

    this.drawerSubtoggles.forEach(function (toggle) {
      self.addListener(toggle, 'click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        self.toggleDrawerSubmenu(toggle);
      });
    });

    this.drawerParentLinks.forEach(function (link) {
      self.addListener(link, 'click', function (event) {
        const item = link.closest('[data-sh-drawer-item]');
        const submenu = item ? item.querySelector('[data-sh-drawer-submenu]') : null;
        const toggle = item ? item.querySelector('[data-sh-drawer-toggle]') : null;
        if (!submenu || !toggle) return;
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }
        self.toggleDrawerSubmenu(toggle);
      });
    });

    this.drawerNavLinks.forEach(function (link) {
      self.addListener(link, 'click', function (event) {
        if (event.defaultPrevented) return;
        if (consumeCurrentPageNavigation(link, event)) return;
        self.closeDrawerForNavigation(link);
      });
    });

    this.desktopSubmenuNavLinks.forEach(function (link) {
      self.addListener(link, 'click', function (event) {
        if (event.defaultPrevented) return;
        consumeCurrentPageNavigation(link, event);
      });
    });

    this.drawerSubmenuNavLinks.forEach(function (link) {
      self.addListener(link, 'click', function (event) {
        if (event.defaultPrevented) return;
        if (consumeCurrentPageNavigation(link, event)) return;
        self.closeDrawerForNavigation(link);
      });
    });

    if (this.drawer) {
      this.addListener(this.drawer, 'click', function (event) {
        const link = event.target && event.target.closest ? event.target.closest('.fff-sh__drawer-item .fff-sh__drawer-link') : null;
        if (!link || !self.drawer.contains(link)) return;
        const item = link.closest('[data-sh-drawer-item]');
        const submenu = item ? item.querySelector('[data-sh-drawer-submenu]') : null;
        const toggle = item ? item.querySelector('[data-sh-drawer-toggle]') : null;
        if (!submenu || !toggle) return;
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }
        self.toggleDrawerSubmenu(toggle);
      }, true);
    }

    this.drawerSpecialLinks.forEach(function (link) {
      let pressingTimer = null;
      const addPressing = function () {
        if (pressingTimer) {
          clearTimeout(pressingTimer);
          pressingTimer = null;
        }
        link.classList.add('is-pressing');
        pressingTimer = self.setTimer(function () {
          link.classList.remove('is-pressing');
          pressingTimer = null;
        }, 180);
      };
      const clearPressing = function () {
        if (pressingTimer) {
          clearTimeout(pressingTimer);
          pressingTimer = null;
        }
        link.classList.remove('is-pressing');
      };
      self.addListener(link, 'pointerdown', addPressing);
      self.addListener(link, 'pointerup', clearPressing);
      self.addListener(link, 'pointercancel', clearPressing);
      self.addListener(link, 'pointerleave', clearPressing);
      self.addListener(link, 'touchend', clearPressing, { passive: true });
      self.addListener(link, 'touchcancel', clearPressing, { passive: true });
      self.addListener(link, 'blur', clearPressing);
      self.addListener(link, 'click', clearPressing);
    });

    if (this.root) {
      this.addListener(this.root, 'mouseleave', function () {
        if (!self.isDesktop()) return;
        self.closeDesktopPanels();
      });
    }

    this.addListener(window, 'resize', this.onResize, { passive: true });
    this.addListener(window, 'scroll', this.onScroll, { passive: true });
    this.addListener(document, 'click', this.onOutsideClick);
    this.addListener(document, 'keydown', this.onKeydown);

    if (this.primaryRoot || this.primaryHeader || this.primaryAnnouncement) {
      this.mutationObserver = new MutationObserver(function () {
        if (self.mutationTicking) return;
        self.mutationTicking = true;
        window.requestAnimationFrame(function () {
          self.syncFromPrimaryHeader();
          self.updateScrollState();
          self.mutationTicking = false;
        });
      });

      if (this.primaryRoot) {
        this.mutationObserver.observe(this.primaryRoot, { attributes: true, attributeFilter: ['class', 'style'] });
      }
      if (this.primaryHeader) {
        this.mutationObserver.observe(this.primaryHeader, { attributes: true, attributeFilter: ['class', 'style'] });
      }
      if (this.primaryAnnouncement) {
        this.mutationObserver.observe(this.primaryAnnouncement, { attributes: true, attributeFilter: ['class', 'style'] });
      }
    }
  };

  SecondHeader.prototype.refresh = function () {
    const context = getContext();
    const shouldBeActive = context.variant === this.variant;

    this.updateAnnouncementCopy();
    this.setActive(shouldBeActive);
    if (shouldBeActive) {
      this.syncFromPrimaryHeader();
      this.updateScrollState();
      this.syncDrawerToggleColumn();
      this.updatePrimaryHeaderVisibility();
      if (this.pendingDrawerCloseForNav) {
        this.pendingDrawerCloseForNav = false;
        this.setTimer(() => {
          this.closeDrawer();
        }, 40);
      }
    } else if (this.pendingDrawerCloseForNav) {
      this.pendingDrawerCloseForNav = false;
      this.closeDrawer();
    }
  };

  SecondHeader.prototype.updatePrimaryHeaderVisibility = function () {
    const shouldCoverPrimary = this.active &&
      this.root.classList.contains('is-active') &&
      this.root.classList.contains('is-intro-ready') &&
      !this.root.classList.contains('is-intro-pending') &&
      !this.root.classList.contains('is-shell-collapsed');
    const shouldForcePrimaryExpanded = this.active && this.root.classList.contains('is-shell-collapsed');

    this.bodyCoveringClasses.forEach((className) => {
      document.body.classList.toggle(className, shouldCoverPrimary);
    });
    this.bodyCollapsedClasses.forEach((className) => {
      document.body.classList.toggle(className, shouldForcePrimaryExpanded);
    });
  };

  SecondHeader.prototype.setActive = function (shouldBeActive) {
    if (shouldBeActive === this.active) {
      if (!shouldBeActive) return;
      this.root.hidden = false;
      this.root.classList.add('is-active');
      this.updatePrimaryHeaderVisibility();
      return;
    }

    this.active = shouldBeActive;

    if (!shouldBeActive) {
      this.bodyCoveringClasses.forEach((className) => document.body.classList.remove(className));
      this.bodyCollapsedClasses.forEach((className) => document.body.classList.remove(className));
      this.mobileManualExpandReveal = false;
      this.closeDrawer();
      this.closeDesktopPanels();
      this.root.classList.remove('is-active', 'is-intro-pending', 'is-intro-ready', 'is-shell-collapsed', 'is-mobile-hidden', 'is-auto-ab-hidden');
      this.root.hidden = true;
      return;
    }

    this.root.hidden = false;
    this.root.classList.add('is-active');
    this.root.classList.remove('is-shell-collapsed');
    this.updatePrimaryHeaderVisibility();
    this.applyIntro();
  };

  SecondHeader.prototype.applyIntro = function () {
    let hasSeen = false;
    try {
      hasSeen = window.sessionStorage.getItem(this.storageKey) === '1';
    } catch (_) {
      hasSeen = false;
    }

    if (prefersReducedMotion.matches || hasSeen) {
      this.root.classList.remove('is-intro-pending');
      this.root.classList.add('is-intro-ready');
      this.updatePrimaryHeaderVisibility();
      return;
    }

    this.root.classList.remove('is-intro-ready');
    this.root.classList.add('is-intro-pending');

    this.setTimer(() => {
      this.root.classList.remove('is-intro-pending');
      this.root.classList.add('is-intro-ready');
      this.updatePrimaryHeaderVisibility();
      try {
        window.sessionStorage.setItem(this.storageKey, '1');
      } catch (_) {}
      this.blinkToggle();
    }, this.introDelay);
  };

  SecondHeader.prototype.blinkToggle = function () {
    if (!this.collapseBtn) return;
    this.collapseBtn.classList.remove('is-blink-once');
    void this.collapseBtn.offsetWidth;
    this.collapseBtn.classList.add('is-blink-once');
    this.setTimer(() => {
      if (this.collapseBtn) {
        this.collapseBtn.classList.remove('is-blink-once');
      }
    }, 920);
  };

  SecondHeader.prototype.updateAnnouncementCopy = function () {
    if (!this.announcementExpanded || !this.announcementCollapsed) return;
    const mobile = this.isMobile();
    const expanded = mobile ? (this.root.dataset.msgMobile || this.root.dataset.msgDesktop || '') : (this.root.dataset.msgDesktop || this.root.dataset.msgMobile || '');
    const collapsed = mobile ? (this.root.dataset.msgCollapsedMobile || expanded) : (this.root.dataset.msgCollapsedDesktop || expanded);
    this.announcementExpanded.textContent = expanded;
    this.announcementCollapsed.textContent = collapsed;
  };

  SecondHeader.prototype.syncFromPrimaryHeader = function () {
    if (!this.active) return;

    if (this.primaryAnnouncement) {
      const announcementStyles = window.getComputedStyle(this.primaryAnnouncement);
      const announcementHeight = this.primaryAnnouncement.getBoundingClientRect().height;
      const innerHeight = parseFloat(announcementStyles.height) || 0;
      const padTop = parseFloat(announcementStyles.paddingTop) || 0;
      const padBottom = parseFloat(announcementStyles.paddingBottom) || 0;
      if (announcementHeight > 0) {
        if (this.isMobile()) {
          this.mobileAnnouncementHeight = Math.max(this.mobileAnnouncementHeight, announcementHeight);
          this.mobileAnnouncementInnerHeight = Math.max(this.mobileAnnouncementInnerHeight, innerHeight);
          this.mobileAnnouncementPadTop = Math.max(this.mobileAnnouncementPadTop, padTop);
          this.mobileAnnouncementPadBottom = Math.max(this.mobileAnnouncementPadBottom, padBottom);
        } else {
          this.desktopAnnouncementHeight = Math.max(this.desktopAnnouncementHeight, announcementHeight);
          this.desktopAnnouncementInnerHeight = Math.max(this.desktopAnnouncementInnerHeight, innerHeight);
          this.desktopAnnouncementPadTop = Math.max(this.desktopAnnouncementPadTop, padTop);
          this.desktopAnnouncementPadBottom = Math.max(this.desktopAnnouncementPadBottom, padBottom);
        }
      }
    }

    if (this.primarySection) {
      const sectionStyles = window.getComputedStyle(this.primarySection);
      const desktopTotal = parseFloat(sectionStyles.getPropertyValue('--h2-ab-total-h')) || 0;
      if (desktopTotal > 0) {
        this.desktopAnnouncementHeight = Math.max(this.desktopAnnouncementHeight, desktopTotal);
      }
    }

    const syncedAnnouncementHeight = this.isMobile()
      ? (this.mobileAnnouncementHeight || this.desktopAnnouncementHeight || 44)
      : (this.desktopAnnouncementHeight || this.mobileAnnouncementHeight || 44);
    const syncedAnnouncementInnerHeight = this.isMobile()
      ? (this.mobileAnnouncementInnerHeight || this.desktopAnnouncementInnerHeight || Math.max(0, syncedAnnouncementHeight - 16))
      : (this.desktopAnnouncementInnerHeight || this.mobileAnnouncementInnerHeight || Math.max(0, syncedAnnouncementHeight - 16));
    const syncedAnnouncementPadTop = this.isMobile()
      ? (this.mobileAnnouncementPadTop || this.desktopAnnouncementPadTop || 8)
      : (this.desktopAnnouncementPadTop || this.mobileAnnouncementPadTop || 8);
    const syncedAnnouncementPadBottom = this.isMobile()
      ? (this.mobileAnnouncementPadBottom || this.desktopAnnouncementPadBottom || 8)
      : (this.desktopAnnouncementPadBottom || this.mobileAnnouncementPadBottom || 8);

    if (syncedAnnouncementHeight > 0) {
      this.root.style.setProperty('--fff-sync-ab-h', syncedAnnouncementHeight + 'px');
    }
    this.root.style.setProperty('--fff-sync-ab-inner-h', syncedAnnouncementInnerHeight + 'px');
    this.root.style.setProperty('--fff-sync-ab-pad-top', syncedAnnouncementPadTop + 'px');
    this.root.style.setProperty('--fff-sync-ab-pad-bottom', syncedAnnouncementPadBottom + 'px');

    if (this.primaryHeader) {
      const headerStyles = window.getComputedStyle(this.primaryHeader);
      const headerHeight = this.primaryHeader.getBoundingClientRect().height;
      this.root.style.setProperty('--fff-sync-header-pad-top', headerStyles.paddingTop || '8px');
      this.root.style.setProperty('--fff-sync-header-pad-bottom', headerStyles.paddingBottom || '8px');
      if (headerHeight > 0) {
        this.root.style.setProperty('--fff-sync-header-h', headerHeight + 'px');
      }
    }

    if (this.primaryRow) {
      const rowStyles = window.getComputedStyle(this.primaryRow);
      const measuredMin = parseFloat(rowStyles.minHeight || '0');
      const measuredHeight = this.primaryRow.getBoundingClientRect().height;
      const resolved = Math.max(measuredMin || 0, measuredHeight || 0, 48);
      this.root.style.setProperty('--fff-sync-row-min-h', resolved + 'px');
    }

    if (this.primaryLeftLogoLink && !this.isMobile()) {
      const logoTransform = window.getComputedStyle(this.primaryLeftLogoLink).transform || 'none';
      this.root.style.setProperty('--fff-logo-transform', logoTransform === 'none' ? 'none' : logoTransform);
    } else {
      this.root.style.setProperty('--fff-logo-transform', 'none');
    }

    this.syncDesktopSubmenuAlignment();
  };

  SecondHeader.prototype.updateScrollState = function () {
    if (!this.active) return;
    if (this.root.classList.contains('is-shell-collapsed')) {
      this.mobileManualExpandReveal = false;
      this.root.classList.remove('is-auto-ab-hidden', 'is-mobile-hidden');
      this.updatePrimaryHeaderVisibility();
      return;
    }
    if (!this.primaryRoot) return;
    const primaryIsMobileHidden = this.primaryRoot.classList.contains('mobile-hidden');
    const primaryIsAnnouncementHidden = this.primaryRoot.classList.contains('ab-hidden');
    if (this.isMobile() && this.mobileManualExpandReveal) {
      this.root.classList.toggle('is-auto-ab-hidden', primaryIsAnnouncementHidden);
      this.root.classList.remove('is-mobile-hidden');
      this.updatePrimaryHeaderVisibility();
      return;
    }
    this.root.classList.toggle('is-auto-ab-hidden', primaryIsAnnouncementHidden);
    this.root.classList.toggle('is-mobile-hidden', this.isMobile() && primaryIsMobileHidden);
    this.updatePrimaryHeaderVisibility();
  };

  SecondHeader.prototype.collapseShell = function () {
    this.closeDrawer();
    this.closeDesktopPanels();
    this.root.classList.add('is-shell-collapsed');
    this.updatePrimaryHeaderVisibility();
  };

  SecondHeader.prototype.expandShell = function () {
    this.root.classList.remove('is-shell-collapsed');
    this.mobileManualExpandReveal = this.isMobile() && (window.scrollY || 0) > 0;
    this.updateScrollState();
    this.updatePrimaryHeaderVisibility();
  };

  SecondHeader.prototype.getDesktopPanel = function (index) {
    return this.root.querySelector('[data-sh-desktop-panel="' + index + '"]');
  };

  SecondHeader.prototype.getDesktopLink = function (index) {
    return this.root.querySelector('[data-sh-desktop-toggle="' + index + '"]');
  };

  SecondHeader.prototype.clearDesktopPanelReset = function () {
    if (!this.desktopPanelResetTimer) return;
    window.clearTimeout(this.desktopPanelResetTimer);
    this.desktopPanelResetTimer = null;
  };

  SecondHeader.prototype.syncDesktopSubmenuShell = function (targetPanel) {
    if (!this.submenuShell || !this.desktopPanels.length) return;
    const panel = targetPanel || this.desktopPanels.find((item) => item.classList.contains('is-active')) || this.desktopPanels[0];
    if (!panel) return;
    const nextHeight = panel.scrollHeight || panel.offsetHeight || 0;
    this.submenuShell.style.setProperty('--fff-submenu-shell-h', Math.max(0, nextHeight) + 'px');
  };

  SecondHeader.prototype.resetDesktopSubmenuImage = function (panel) {
    if (!panel) return;
    const images = Array.from(panel.querySelectorAll('[data-sh-submenu-image]'));
    if (!images.length) return;
    const defaultTarget = (panel.dataset.shSubmenuDefaultImage || '').trim();
    images.forEach((image) => {
      const shouldBeActive = defaultTarget ? image.dataset.shSubmenuImage === defaultTarget : false;
      image.classList.toggle('is-active', shouldBeActive);
    });
  };

  SecondHeader.prototype.activateDesktopSubmenuImage = function (link) {
    if (!link) return;
    const target = (link.dataset.shSubmenuImageTarget || '').trim();
    if (!target) return;
    const panel = link.closest('[data-sh-desktop-panel]');
    if (!panel) return;
    panel.querySelectorAll('[data-sh-submenu-image]').forEach((image) => {
      image.classList.toggle('is-active', image.dataset.shSubmenuImage === target);
    });
  };

  SecondHeader.prototype.syncDesktopSubmenuAlignment = function () {
    if (!this.isDesktop() || !this.row) return;

    const rowRect = this.row.getBoundingClientRect();
    const lastMenuLink = this.desktopAllLinks.length ? this.desktopAllLinks[this.desktopAllLinks.length - 1] : null;
    const anchorRect = lastMenuLink ? lastMenuLink.getBoundingClientRect() : (this.desktopNavList ? this.desktopNavList.getBoundingClientRect() : null);
    if (!anchorRect) return;
    const rightPad = Math.max(0, Math.round(rowRect.right - anchorRect.right));

    this.root.style.setProperty('--fff-submenu-right-pad', rightPad + 'px');
  };

  SecondHeader.prototype.syncDrawerToggleColumn = function () {
    if (this.isDesktop() || !this.drawerLinks.length) return;
    let widest = 0;
    this.drawerLinks.forEach((link) => {
      widest = Math.max(widest, Math.ceil(link.getBoundingClientRect().width || 0));
    });
    if (widest > 0) {
      this.root.style.setProperty('--fff-drawer-link-col-w', widest + 'px');
    }
  };

  SecondHeader.prototype.openDesktopPanel = function (index) {
    if (!this.isDesktop()) return;
    if (this.root.classList.contains('is-shell-collapsed')) {
      this.expandShell();
    }

    const targetPanel = this.getDesktopPanel(index);
    const targetLink = this.getDesktopLink(index);
    if (!targetPanel || !targetLink) return;

    this.clearDesktopPanelReset();
    this.syncDesktopSubmenuAlignment();
    this.syncDesktopSubmenuShell(targetPanel);
    this.resetDesktopSubmenuImage(targetPanel);
    this.submenuShell && this.submenuShell.classList.add('is-open');

    this.desktopPanels.forEach((panel) => {
      panel.classList.toggle('is-active', panel === targetPanel);
    });

    this.desktopLinks.forEach((link) => {
      link.setAttribute('aria-expanded', link === targetLink ? 'true' : 'false');
    });

    this.activeDesktopIndex = String(index);
  };

  SecondHeader.prototype.closeDesktopPanels = function () {
    this.clearDesktopPanelReset();
    this.submenuShell && this.submenuShell.classList.remove('is-open');
    this.desktopLinks.forEach((link) => link.setAttribute('aria-expanded', 'false'));
    this.activeDesktopIndex = null;
    this.desktopPanelResetTimer = window.setTimeout(() => {
      if (!this.submenuShell || this.submenuShell.classList.contains('is-open')) return;
      this.desktopPanels.forEach((panel) => panel.classList.remove('is-active'));
      this.desktopPanelResetTimer = null;
    }, 1500);
  };

  SecondHeader.prototype.toggleDesktopPanel = function (index) {
    const normalized = String(index);
    if (this.activeDesktopIndex === normalized) {
      this.closeDesktopPanels();
      return;
    }
    this.openDesktopPanel(normalized);
  };

  SecondHeader.prototype.openDrawer = function () {
    this.expandShell();
    this.root.classList.add('is-mobile-menu-open');
    if (this.drawer) {
      this.drawer.setAttribute('aria-hidden', 'false');
    }
    if (this.drawerOpenBtn) {
      this.drawerOpenBtn.setAttribute('aria-expanded', 'true');
    }
  };

  SecondHeader.prototype.closeDrawer = function () {
    this.root.classList.remove('is-mobile-menu-open');
    if (this.drawer) {
      this.drawer.setAttribute('aria-hidden', 'true');
    }
    if (this.drawerOpenBtn) {
      this.drawerOpenBtn.setAttribute('aria-expanded', 'false');
    }
    this.closeDrawerSubmenus();
  };

  SecondHeader.prototype.closeDrawerForNavigation = function (link) {
    if (!this.drawer || !this.root.classList.contains('is-mobile-menu-open')) return false;
    if (!link || !this.drawer.contains(link)) return false;
    this.pendingDrawerCloseForNav = true;
    this.drawerSpecialLinks.forEach((specialLink) => specialLink.classList.remove('is-pressing'));
    this.closeDesktopPanels();
    this.setTimer(() => {
      if (!this.pendingDrawerCloseForNav) return;
      this.pendingDrawerCloseForNav = false;
      this.closeDrawer();
    }, this.getDrawerCloseLeadMs());
    return true;
  };

  SecondHeader.prototype.closeMenuForNavigation = function (link) {
    this.closeDesktopPanels();
    return this.closeDrawerForNavigation(link);
  };

  SecondHeader.prototype.closeDrawerSubmenus = function () {
    this.drawerSubtoggles.forEach((toggle) => toggle.setAttribute('aria-expanded', 'false'));
    const submenus = this.root.querySelectorAll('[data-sh-drawer-submenu]');
    submenus.forEach((panel) => setExpandableState(panel, false));
  };

  SecondHeader.prototype.toggleDrawerSubmenu = function (toggle) {
    const item = toggle.closest('[data-sh-drawer-item]');
    const submenu = item ? item.querySelector('[data-sh-drawer-submenu]') : null;
    if (!submenu) return;

    const shouldOpen = !submenu.classList.contains('is-open');

    this.root.querySelectorAll('[data-sh-drawer-submenu]').forEach((panel) => {
      const panelToggle = panel.closest('[data-sh-drawer-item]') ? panel.closest('[data-sh-drawer-item]').querySelector('[data-sh-drawer-toggle]') : null;
      const isTarget = panel === submenu;
      setExpandableState(panel, isTarget && shouldOpen);
      if (panelToggle) {
        panelToggle.setAttribute('aria-expanded', isTarget && shouldOpen ? 'true' : 'false');
      }
    });
  };

  SecondHeader.prototype.handleOutsideClick = function (event) {
    if (!this.active) return;
    if (this.root.contains(event.target)) {
      if (this.isDesktop()) {
        const insideDesktopMenu = event.target.closest('.fff-sh__desktop-nav, .fff-sh__submenu-shell');
        if (!insideDesktopMenu) {
          this.closeDesktopPanels();
        }
      }
      return;
    }
    if (!this.isDesktop() && this.drawer && this.drawer.contains(event.target)) return;
    this.closeDesktopPanels();
  };

  SecondHeader.prototype.handleResize = function () {
    this.updateAnnouncementCopy();
    this.syncFromPrimaryHeader();
    this.updateScrollState();
    this.syncDesktopSubmenuShell();
    if (this.isDesktop()) {
      this.closeDrawer();
    } else {
      this.closeDesktopPanels();
    }
    this.syncDrawerToggleColumn();
    this.syncDesktopSubmenuAlignment();
  };

  SecondHeader.prototype.handleScroll = function () {
    if (this.scrollTicking) return;
    this.scrollTicking = true;
    window.requestAnimationFrame(() => {
      this.mobileManualExpandReveal = false;
      this.syncFromPrimaryHeader();
      this.updateScrollState();
      this.scrollTicking = false;
    });
  };

  SecondHeader.prototype.handleKeydown = function (event) {
    if (event.key !== 'Escape') return;
    this.closeDrawer();
    this.closeDesktopPanels();
  };

  SecondHeader.prototype.cleanup = function () {
    this.bodyCoveringClasses.forEach((className) => document.body.classList.remove(className));
    this.bodyCollapsedClasses.forEach((className) => document.body.classList.remove(className));
    this.mobileManualExpandReveal = false;
    this.closeDrawer();
    this.closeDesktopPanels();
    this.clearDesktopPanelReset();

    this.cleanupFns.forEach(function (off) {
      try {
        off();
      } catch (_) {}
    });
    this.cleanupFns = [];

    this.timers.forEach(function (id) {
      clearTimeout(id);
    });
    this.timers = [];

    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
      this.mutationObserver = null;
    }
  };

  function SecondFooter(root) {
    this.root = root;
    this.variant = (root.dataset.sfVariant || '').trim().toLowerCase();
    this.active = false;
    this.refresh();
  }

  SecondFooter.prototype.refresh = function () {
    const context = getContext();
    this.setActive(context.variant === this.variant);
  };

  SecondFooter.prototype.setActive = function (shouldBeActive) {
    const changed = shouldBeActive !== this.active || this.root.hidden === shouldBeActive;
    this.active = shouldBeActive;
    this.root.hidden = !shouldBeActive;
    this.root.classList.toggle('is-active', shouldBeActive);
    this.root.setAttribute('aria-hidden', shouldBeActive ? 'false' : 'true');
    if (changed) requestLayoutSettle();
  };

  SecondFooter.prototype.cleanup = function () {
    this.setActive(false);
  };

  function mountRoot(root) {
    if (!root) return;
    const existing = instances.get(root);
    if (existing) {
      existing.refresh();
      return;
    }

    const instance = new SecondHeader(root);
    instances.set(root, instance);
    root.__secondHeaderCleanup = function () {
      instance.cleanup();
      instances.delete(root);
    };
  }

  function mountFooterRoot(root) {
    if (!root) return;
    const existing = footerInstances.get(root);
    if (existing) {
      existing.refresh();
      return;
    }

    const instance = new SecondFooter(root);
    footerInstances.set(root, instance);
    root.__secondFooterCleanup = function () {
      instance.cleanup();
      footerInstances.delete(root);
    };
  }

  function initAllFooters() {
    document.querySelectorAll('[data-sf-root]').forEach(mountFooterRoot);
  }

  function refreshAllFooters() {
    document.querySelectorAll('[data-sf-root]').forEach(function (root) {
      const instance = footerInstances.get(root);
      if (instance) {
        instance.refresh();
      } else {
        mountFooterRoot(root);
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-sh-root]').forEach(mountRoot);
    initAllFooters();
  }

  function refreshAll() {
    document.querySelectorAll('[data-sh-root]').forEach(function (root) {
      const instance = instances.get(root);
      if (instance) {
        instance.refresh();
      } else {
        mountRoot(root);
      }
    });
    refreshAllFooters();
  }

  window.__shCloseMenuForNavigation = function (link) {
    let handled = false;
    instances.forEach(function (instance) {
      if (!instance || typeof instance.closeMenuForNavigation !== 'function') return;
      handled = instance.closeMenuForNavigation(link) || handled;
    });
    return handled;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  if (window.barba && window.barba.hooks && typeof window.barba.hooks.afterEnter === 'function') {
    window.barba.hooks.afterEnter(function () {
      refreshAll();
      window.requestAnimationFrame(refreshAll);
    });
  }

  if (window.barba && window.barba.hooks && typeof window.barba.hooks.after === 'function') {
    window.barba.hooks.after(function () {
      refreshAll();
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    if (!event.target.matches || !event.target.matches('[id^="shopify-section-"]')) return;
    const root = event.target.querySelector('[data-sh-root]');
    if (root) mountRoot(root);
    const footerRoot = event.target.querySelector('[data-sf-root]');
    if (footerRoot) mountFooterRoot(footerRoot);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (!event || !event.target) return;
    const root = event.target.querySelector && event.target.querySelector('[data-sh-root]');
    if (root) {
      const instance = instances.get(root);
      if (instance) {
        instance.cleanup();
        instances.delete(root);
      }
    }
    const footerRoot = event.target.querySelector && event.target.querySelector('[data-sf-root]');
    if (footerRoot) {
      const footerInstance = footerInstances.get(footerRoot);
      if (footerInstance) {
        footerInstance.cleanup();
        footerInstances.delete(footerRoot);
      }
    }
  });
})();
